import { ApiNewDokumentPowiazanyDalDto, EgibObject } from '@gk/gk-modules';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';

export interface TSFNNewRequestDto extends ExtendedApplicantRequestDto {
  IloscDrzew: number;
  OpisDrzew: string;
}

export class TSFNNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    proxyDetailsCheckbox: boolean,
    proxyDetailsArray: InvestorDetails[],
    public treesNumber: number,
    public treesDescription: string,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }

  static fromAppToApi(
    data: TSFNNewRequest,
    parcels: EgibObject[],
    issueRanges: string[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): TSFNNewRequestDto {
    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        files,
        parcels,
        issueRanges,
      }),
      IloscDrzew: data.treesNumber,
      OpisDrzew: data.treesDescription,
    };
  }
}

export interface TSFNNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: TSFNNewRequest;
  parcels: EgibObject[];
  issueRanges: string[];
}
